import { useState } from "react"

export type UseDraftValueReturn<T> = [draft: T, setDraft: (value: T) => void]

// Mirror an external value as local draft state. The user can type an invalid
// date (From > To) and the drawer keeps it on-screen with an error rather than
// snapping back, but external resets (chip clear, browser back) still flow in.
// React docs: "Adjusting some state when a prop changes" — compare during render.
export const useDraftValue = <T>(externalValue: T): UseDraftValueReturn<T> => {
  const [draft, setDraft] = useState<T>(externalValue)
  const [prev, setPrev] = useState<T>(externalValue)
  if (prev !== externalValue) {
    setPrev(externalValue)
    setDraft(externalValue)
  }
  return [draft, setDraft]
}
